<div class="grow-search-input-wrapper" [class.is-expanded]="isExpanded">
    <div class="autocomplete-container" fxlayout="row" fxLayoutAlign="space-between center">
        <input
            #searchInputElement
            (focus)="onFocus()"
            (blur)="onBlur()"
            type="search"
            [placeholder]="'GENERAL.SEARCH' | translate"
            attr.aria-label="{{ 'GENERAL.SEARCH' | translate }}"
            autocomplete="off"
            [formControl]="searchInput"
            (keyup.enter)="search(searchInput.value)"
        />
        <button
            mat-icon-button
            class="search-icon"
            (click)="search(searchInput.value)"
            attr.aria-label="{{ 'GENERAL.SEARCH' | translate }} {{ 'GENERAL.LABEL.ARIA_ACTION' | translate }}"
        >
            <mat-icon>search</mat-icon>
        </button>
        <button
            mat-icon-button
            class="clear-icon"
            (click)="search('')"
            *ngIf="searchInput.value"
            attr.aria-label="{{ 'GENERAL.BUTTON.CLOSE' | translate }} {{ 'GENERAL.LABEL.ARIA_ACTION' | translate }}"
        >
            <mat-icon>close</mat-icon>
        </button>

        <div class="autocomplete-items mat-elevation-z2" *ngIf="lastSearches.length && isDropdownVisible">
            <div
                fxlayout="row"
                fxLayoutAlign="flex-start space-between"
                class="autocomplete-item"
                (mousedown)="search(lastSearch); $event.preventDefault()"
                *ngFor="let lastSearch of lastSearches; let i = index"
            >
                <div class="w-100-p" fxlayout="row" fxLayoutAlign="flex-start center">
                    <mat-icon attr.aria-label="{{ 'GENERAL.LABEL.RESTORE' | translate }}" class="mr-12">restore</mat-icon>
                    <span>{{ lastSearch }}</span>
                </div>
                <mat-icon
                    class="remove-autocomplete-item"
                    attr.aria-label="{{ 'GENERAL.BUTTON.CLOSE' | translate }} {{ 'GENERAL.LABEL.ARIA_ACTION' | translate }}"
                    (mousedown)="removeLastSearch(lastSearch, $event)"
                    >close</mat-icon
                >
            </div>
        </div>
    </div>
</div>
